import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
const TabTitle = ({ title ='' , isDeal =false  })=>/*#__PURE__*/ _jsx("div", {
        "data-testid": "TabTitle",
        className: classNames({
            'is-deal': isDeal
        }),
        children: /*#__PURE__*/ _jsx("span", {
            children: title
        })
    });
export default TabTitle;

//# sourceMappingURL=index.js.map